import { FormArray, ValidationErrors, ValidatorFn } from '@angular/forms';

export function checkboxValidator(minRequired = 1): ValidatorFn {
  return (formArray: FormArray): ValidationErrors | null => {
    
    const checkedCount = formArray.controls.filter(ctrl => ctrl.value === true).length;
    const hasMinimumRequiredChecked = checkedCount >= minRequired;

    formArray.controls.forEach(ctrl => {
      if (hasMinimumRequiredChecked || ctrl.value === true) {
        ctrl.markAsTouched();
        ctrl.setErrors(null);
        return;
      }

      ctrl.setErrors({ requireCheckboxToBeChecked: true });
    });

    return hasMinimumRequiredChecked ? null : { requireCheckboxToBeChecked: true };
  };
}
